import { useEffect, useState, useRef } from 'react';

const useIsVisible = <T extends HTMLElement>() => {
  const [isVisible, setIsVisible] = useState(false);
  const HTMLElementRef = useRef<T>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const isElementVisible = entries[0].isIntersecting;
      if (!isVisible && isElementVisible) {
        setIsVisible(true);
      } else if (isVisible && !isElementVisible) {
        setIsVisible(false);
      }
    });
    if (HTMLElementRef.current) observer.observe(HTMLElementRef.current);
    return () => {
      observer.disconnect();
    };
  }, [HTMLElementRef, isVisible]);

  return { isVisible, ref: HTMLElementRef };
};

export default useIsVisible;
